// ----------------------------------------------------------------------------
// Snippet: Search
// ----------------------------------------------------------------------------
// Search bar, on header and on the Search Results template.
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_search-form.scss';


// ----------------------------------------------------------------------------
// Component: Search
// ----------------------------------------------------------------------------
//
// Search bar, on header and on the Search Results template.
//
// ----------------------------------------------------------------------------

const SEARCH_FORM = '.search-box--header';
const SEARCH_FORM_AFTER = '.search-box--header:after';
const SEARCH_ICON = '.search-box__toggle';
const SEARCH_INPUT = '.search__input';

// If you click anywhere outside of the search, close it
$('body').on('click', function(event) {
    if (!$(event.target).closest('.form--search').length && !$(event.target).closest(SEARCH_ICON).length) {
        $(SEARCH_FORM).removeClass('is-active');
    }
});


// When you click the search icon, toggle the open state
$(SEARCH_ICON).on('click', function(event) {
  event.preventDefault();
  let $currentParent = $(SEARCH_ICON).closest('header').find(SEARCH_FORM);

  $currentParent.toggleClass('is-active');

  if($currentParent.hasClass('is-active')){
    $currentParent.find(SEARCH_INPUT).focus();
  }


  // Clear header classes for mobile
  $('.header').removeClass('js--isOpen');
  $('.menu--default').removeClass('js--isOpen');
  $('.header__link--menu').removeClass('js--isOpen');
});

// Close header search when pressing Escape key
$(document).on('keydown', function(e) {

  if (e.key == "Escape") {
    if($(SEARCH_FORM).hasClass('is-active')) {
      $(SEARCH_FORM).removeClass('is-active');
    }
  }
});


// Allows label on mobile to also target the search
$('.search-box--header .form__label').on('click', function(event) {
  $(this).closest('.search-box').toggleClass('is-active');
});
